// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd7a3e8c","453":"9c39751b","455":"05ca7e3b","977":"80e56327"}[chunkId] + ".chunk.js";
};